import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, featuredComics } from '@/mocks/comics';

const categoryDescriptions: Record<string, string> = {
  rexue: '热血战斗类韩漫，涵盖武侠、格斗、超能力对战等题材。这里有最燃的战斗场面和最热血的成长故事，让你感受拳拳到肉的视觉冲击。',
  lianai: '恋爱甜宠类韩漫，收录校园恋爱、都市爱情、奇幻虐恋等类型。甜蜜浪漫的爱情故事，精致唯美的画风，打动每一颗少女心。',
  xuanyi: '悬疑惊悚类韩漫，包含推理侦探、心理恐怖、灵异怪谈等主题。层层递进的悬疑剧情，让你屏息凝神欲罢不能。',
  qihuan: '奇幻冒险类韩漫，汇集异世界穿越、魔法战斗、末世生存等题材。天马行空的想象力，带你进入不可思议的奇幻世界。',
  xiju: '搞笑日常类韩漫，收录轻松喜剧、校园搞笑、治愈日常等类型。笑料不断的日常故事，帮你卸下一天的疲惫。',
  dushi: '都市职场类韩漫，涵盖职场逆袭、都市异能、现实主义等题材。在钢筋水泥的丛林中，书写属于普通人的不平凡故事。',
};

const comicCoverImages: Record<string, string> = {
  'jiansheng-jianghu': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%2C%20martial%20arts%20swordsman%20character%20in%20ancient%20china%20setting%2C%20dramatic%20illustration%2C%20dark%20moody%20background%2C%20professional%20korean%20comic%20artwork%2C%20cinematic%20lighting%2C%20rich%20details%2C%20clean%20composition&width=500&height=667&seq=comic-cover-jiansheng-07&orientation=portrait',
  'milian-xingkong': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20romance%20cover%20art%2C%20young%20couple%20under%20starry%20night%20sky%2C%20warm%20emotional%20illustration%2C%20dark%20dreamy%20background%2C%20professional%20korean%20comic%20artwork%2C%20soft%20cinematic%20lighting%2C%20beautiful%20composition&width=500&height=667&seq=comic-cover-milian-07&orientation=portrait',
  'anying-chengbao': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20mystery%20thriller%20cover%20art%2C%20detective%20character%20in%20gothic%20castle%2C%20dark%20suspenseful%20illustration%2C%20shadowy%20atmosphere%2C%20professional%20korean%20comic%20artwork%2C%20cinematic%20horror%20lighting%2C%20dramatic%20composition&width=500&height=667&seq=comic-cover-anying-07&orientation=portrait',
  'moshi-yongzhe': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20post%20apocalyptic%20cover%20art%2C%20hero%20with%20lightning%20powers%2C%20wasteland%20background%2C%20dark%20dramatic%20illustration%2C%20professional%20korean%20comic%20artwork%2C%20epic%20cinematic%20lighting%2C%20dynamic%20composition&width=500&height=667&seq=comic-cover-moshi-07&orientation=portrait',
  'xingfu-canting': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20food%20slice%20of%20life%20cover%20art%2C%20warm%20restaurant%20setting%2C%20cozy%20atmosphere%2C%20heartwarming%20illustration%2C%20professional%20korean%20comic%20artwork%2C%20soft%20warm%20lighting%2C%20charming%20composition&width=500&height=667&seq=comic-cover-xingfu-07&orientation=portrait',
  'jinfu-zongcai': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20office%20romance%20cover%20art%2C%20handsome%20CEO%20character%20in%20modern%20city%2C%20sophisticated%20atmosphere%2C%20professional%20korean%20comic%20artwork%2C%20elegant%20lighting%2C%20clean%20stylish%20composition&width=500&height=667&seq=comic-cover-jinfu-07&orientation=portrait',
  'wudao-zhi-zun': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20martial%20arts%20cover%20art%2C%20muscular%20fighter%20character%20with%20glowing%20fists%2C%20dramatic%20dark%20background%2C%20professional%20korean%20comic%20artwork%2C%20intense%20cinematic%20lighting%2C%20powerful%20composition&width=500&height=667&seq=comic-cover-wudao-08&orientation=portrait',
  'shenquan-wudi': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20boxing%20fighter%20cover%20art%2C%20underground%20boxer%20character%20with%20bandaged%20hands%2C%20dark%20gritty%20atmosphere%2C%20professional%20korean%20comic%20artwork%2C%20dramatic%20street%20lighting%2C%20raw%20composition&width=500&height=667&seq=comic-cover-shenquan-08&orientation=portrait',
  'yinghua-shuxia': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20spring%20romance%20cover%20art%2C%20gentle%20female%20character%20under%20cherry%20blossoms%2C%20soft%20pink%20tones%2C%20dark%20dreamy%20background%2C%20professional%20korean%20comic%20artwork%2C%20delicate%20warm%20lighting%2C%20romantic%20composition&width=500&height=667&seq=comic-cover-yinghua-08&orientation=portrait',
  'mimi-huayuan': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20fantasy%20romance%20cover%20art%2C%20body%20swap%20romantic%20comedy%20theme%2C%20elegant%20characters%2C%20dark%20mysterious%20background%20with%20garden%20elements%2C%20professional%20korean%20comic%20artwork%2C%20enchanting%20lighting&width=500&height=667&seq=comic-cover-mimi-08&orientation=portrait',
  'diqi-ceng': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20horror%20thriller%20cover%20art%2C%20eerie%20apartment%20building%20with%20shadowy%20figure%2C%20dark%20terrifying%20atmosphere%2C%20professional%20korean%20comic%20artwork%2C%20chilling%20horror%20lighting%2C%20suspenseful%20composition&width=500&height=667&seq=comic-cover-diqiceng-08&orientation=portrait',
  'wuye-zhuizong': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20crime%20thriller%20cover%20art%2C%20detective%20chasing%20suspect%20at%20night%2C%20dark%20urban%20atmosphere%2C%20professional%20korean%20comic%20artwork%2C%20noir%20cinematic%20lighting%2C%20intense%20composition&width=500&height=667&seq=comic-cover-wuye-08&orientation=portrait',
  'long-zhi-gu': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20fantasy%20adventure%20cover%20art%2C%20dragon%20rider%20character%20with%20majestic%20dragon%2C%20dark%20epic%20atmosphere%20with%20mythical%20elements%2C%20professional%20korean%20comic%20artwork%2C%20magical%20lighting%2C%20grand%20composition&width=500&height=667&seq=comic-cover-longzhi-08&orientation=portrait',
  'mofa-jiyuan': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20magic%20school%20cover%20art%2C%20young%20wizard%20student%20casting%20spell%2C%20dark%20mystical%20atmosphere%2C%20professional%20korean%20comic%20artwork%2C%20magical%20glowing%20effects%2C%20enchanting%20composition&width=500&height=667&seq=comic-cover-mofajy-08&orientation=portrait',
  'linjia-xiaomei': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20comedy%20slice%20of%20life%20cover%20art%2C%20cheerful%20cute%20girl%20character%20with%20bright%20expression%2C%20dark%20warm%20background%2C%20professional%20korean%20comic%20artwork%2C%20happy%20lighting%2C%20playful%20composition&width=500&height=667&seq=comic-cover-linjia-08&orientation=portrait',
  'feichai-nixi': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20school%20comeback%20cover%20art%2C%20determined%20student%20character%20rising%20from%20failure%2C%20dark%20motivational%20atmosphere%2C%20professional%20korean%20comic%20artwork%2C%20inspiring%20lighting%2C%20triumphant%20composition&width=500&height=667&seq=comic-cover-feichai-08&orientation=portrait',
  'shanghai-fuchen': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20business%20drama%20cover%20art%2C%20ambitious%20businessman%20character%20in%20corporate%20setting%2C%20dark%20sophisticated%20atmosphere%2C%20professional%20korean%20comic%20artwork%2C%20sleek%20office%20lighting%2C%20power%20composition&width=500&height=667&seq=comic-cover-shanghai-08&orientation=portrait',
  'zongjian-daren': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20office%20life%20cover%20art%2C%20strict%20female%20boss%20character%20in%20advertising%20agency%2C%20dark%20modern%20atmosphere%2C%20professional%20korean%20comic%20artwork%2C%20stylish%20workplace%20lighting%2C%20sharp%20composition&width=500&height=667&seq=comic-cover-zongjian-08&orientation=portrait',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center bg-background-50 pt-20">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-50 mb-4">分类不存在</h1>
            <Link to="/" className="text-primary-400 hover:text-primary-300 transition-colors">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const comics = featuredComics.filter((c) => c.category === category.name);

  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full min-h-[360px] md:min-h-[420px] flex items-center overflow-hidden bg-background-50 pt-16">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20korean%20manhwa%20category%20page%20background%2C%20abstract%20comic%20panel%20collage%20with%20dramatic%20lighting%2C%20deep%20charcoal%20and%20black%20background%20with%20subtle%20warm%20glow%2C%20atmospheric%20moody%20aesthetic%2C%20professional%20webtoon%20style&width=1600&height=900&seq=category-hero-02&orientation=landscape"
              alt={category.name}
              className="w-full h-full object-cover object-top opacity-30"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-background-50/90 via-background-50/60 to-background-50"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/40 to-transparent"></div>
          </div>

          <div className="relative w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-foreground-300 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-300">分类</span>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-200 font-medium">{category.name}</span>
            </nav>
            <h1 className="font-heading text-4xl md:text-6xl font-black text-foreground-50">
              {category.name}
            </h1>
            <p className="mt-4 text-base md:text-lg text-foreground-400 max-w-xl">
              {(categoryDescriptions as Record<string, string>)[slug || ''] || `浏览${category.name}类正版韩漫，共收录${category.count}部作品。`}
            </p>
            <p className="mt-2 text-sm text-foreground-500">
              共收录 <strong className="text-foreground-300">{category.count}</strong> 部正版韩漫作品
            </p>
          </div>
        </section>

        <section className="w-full py-8 md:py-10 bg-background-50 border-b border-background-200/40">
          <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10">
            <div className="flex items-center gap-2 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-5 py-2.5 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-foreground-50 font-medium'
                      : 'bg-background-200/50 text-foreground-400 hover:bg-background-200 hover:text-foreground-200 border border-background-300/40'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10">
            <div className="flex items-center justify-between mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
                {category.name} · 全部作品
              </h2>
              <span className="text-sm text-foreground-500">
                共 {comics.length} 部
              </span>
            </div>

            {comics.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                {comics.map((comic) => (
                  <article key={comic.id} className="group flex flex-col">
                    <Link
                      to={`/comic/${comic.slug}`}
                      className="relative rounded-2xl overflow-hidden bg-background-200/50 aspect-[3/4] block cursor-pointer"
                    >
                      <img
                        src={comicCoverImages[comic.slug]}
                        alt={comic.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        title={`${comic.title} - 正版韩漫`}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
                      {comic.status === '已完结' && (
                        <div className="absolute top-3 left-3">
                          <span className="px-2.5 py-1 text-[10px] font-medium bg-accent-500 text-background-950 rounded-full">
                            已完结
                          </span>
                        </div>
                      )}
                      {comic.isNew && (
                        <div className="absolute top-3 left-3">
                          <span className="px-2.5 py-1 text-[10px] font-medium bg-primary-500 text-foreground-50 rounded-full">
                            新作
                          </span>
                        </div>
                      )}
                      <div className="absolute bottom-0 left-0 right-0 p-4">
                        <h3 className="text-lg font-semibold text-foreground-50">{comic.title}</h3>
                        <p className="text-sm text-foreground-400 mt-1">{comic.updateInfo}</p>
                      </div>
                    </Link>
                    <div className="mt-3 px-1 flex items-center justify-between">
                      <span className="text-xs text-foreground-500">
                        评分 {comic.rating} · {comic.chapters}话
                      </span>
                      <Link
                        to={`/comic/${comic.slug}`}
                        className="text-xs text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        立即阅读 <i className="ri-arrow-right-line"></i>
                      </Link>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500 text-lg">该分类暂无作品，敬请期待</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${category.name} - 虚空韩漫网`,
            description: (categoryDescriptions as Record<string, string>)[slug || ''] || `浏览${category.name}类正版韩漫`,
            inLanguage: 'zh-CN',
            isPartOf: {
              '@type': 'WebSite',
              name: '虚空韩漫网',
              url: 'http://metcw.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'http://metcw.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '分类',
                item: 'http://metcw.com/category',
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: category.name,
              },
            ],
          }),
        }}
      />
    </>
  );
}